// DESCRIPTION: Pure payment method selector for booking flows.
// Renders radio buttons for choosing between Stripe and manual payment.

import React from 'react';
import { __ } from '@wordpress/i18n';

/**
 * PaymentMethodPicker — a pure component for selecting a payment method.
 *
 * @param {Object}   props
 * @param {string}   props.selected       Currently selected method: 'stripe' or 'manual'.
 * @param {Function} props.onSelect       Called with the selected method string.
 * @param {string}   [props.manualLabel]  Custom label for manual payment option.
 * @param {string}   [props.className=''] Additional CSS class names.
 */
const PaymentMethodPicker = ( {
    selected = 'stripe',
    onSelect,
    manualLabel = '',
    className = '',
} ) => {
    return (
        <div className={ `nb-payment-method-picker ${ className }`.trim() }>
            <label className="nb-payment-method-picker__label">
                { __( 'Payment method', 'nemtly-booking' ) }
            </label>
            <div className="nb-payment-method-picker__options">
                <label className="nb-payment-method-picker__option">
                    <input
                        type="radio"
                        name="payment_method"
                        value="stripe"
                        checked={ selected === 'stripe' }
                        onChange={ () => onSelect( 'stripe' ) }
                        className="nb-payment-method-picker__radio"
                    />
                    <span className="nb-payment-method-picker__text">
                        { __( 'Pay by card', 'nemtly-booking' ) }
                    </span>
                </label>
                <label className="nb-payment-method-picker__option">
                    <input
                        type="radio"
                        name="payment_method"
                        value="manual"
                        checked={ selected === 'manual' }
                        onChange={ () => onSelect( 'manual' ) }
                        className="nb-payment-method-picker__radio"
                    />
                    <span className="nb-payment-method-picker__text">
                        { manualLabel || __( 'Bank transfer / Invoice', 'nemtly-booking' ) }
                    </span>
                </label>
            </div>
        </div>
    );
};

export default PaymentMethodPicker;
